import * as React from "react";
const SvgEyes = (props) => (
  <svg
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.667 6a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0ZM9.333 6a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0c3.728 0 6.86 2.55 7.748 6A8.003 8.003 0 0 1 .252 6C1.14 2.55 4.272 0 8 0Zm0 10.667A6.67 6.67 0 0 1 1.638 6a6.67 6.67 0 0 1 12.724 0A6.67 6.67 0 0 1 8 10.667Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgEyes;
